<div class="header-container">
  <div class="header-wrapper">
    <div class="header-text">
      <div class="header-left">
        @if (!isOnHomePage) {
          <ng-casto-button id="header-home" [faIcon]="faHome" [routerLink]="['/']"></ng-casto-button>
        }
        <h1 [routerLink]="['/']" (click)="clickLogoHandler($event)">
          <span class="sr-only">Castorama</span>
          <img class="brand-logo desktop-logo" src="assets/img/castorama-logo.svg" alt="" />
          <img class="brand-logo mobile-logo" src="assets/img/logo-short.svg" alt="" />
        </h1>
      </div>
      @if (vendorFirstName) {
      <div class="vendor-info large">
        <span class="casto-tag white-tag" [innerHTML]="
              'header.title'
                | translate
                  : {
                      name: vendorFirstName,
                    }
            "></span>
        <ng-casto-button id="header-logout" [faIcon]="faDoorOpen" (click)="askLogout()"></ng-casto-button>
      </div>

      <div class="vendor-info small">
        <span class="casto-tag white-tag" [innerHTML]="
              'header.title-small'
                | translate
                  : {
                      name: vendorFirstName,
                    }
            "></span>
        <ng-casto-button id="header-logout-small" [faIcon]="faDoorOpen" (click)="askLogout()"></ng-casto-button>
      </div>

      <div class="header-quick-actions">
        <ng-casto-help-action></ng-casto-help-action>
        <div class="header-info-action">
          <ng-casto-button id="header-infos" class="action" [faIcon]="faInfoCircle"
            [label]="'communications.header.infosButton' | translate"
            (click)="openCommunicationsPanel()" [title]="'communications.header.information' | translate"
            [attr.aria-label]="(unreadInfoCount === 0
              ? 'communications.header.information'
              : unreadInfoCount === 1
                ? 'communications.header.informationAriaOne'
                : 'communications.header.informationAriaMany') | translate: { count: unreadInfoCount }">
          </ng-casto-button>
          @if (unreadInfoCount > 0) {
          <span class="header-info-unread" aria-hidden="true">{{ unreadInfoCount }}</span>
          }
        </div>
      </div>
      }
    </div>
    <div class="header-buttons">
      @if (headerActions.template(); as headerActionsTemplate) {
      <div class="header-vendor-actions">
        <ng-container *ngTemplateOutlet="headerActionsTemplate"></ng-container>
      </div>
      }
      @if (!vendorContext) {
      @if (storeAppointmentLink || onlineAppointmentLink) {
      <span [innerHTML]="'header.accompaniement' | translate" id="accompaniement"></span>
      }
      @if (storeAppointmentLink) {
      <ng-casto-button class="primary" [faIcon]="faStore" [label]="'header.store-appointment-link' | translate"
        (click)="goToStoreAppointmentUrl()"></ng-casto-button>
      }
      @if (onlineAppointmentLink) {
      <ng-casto-button class="primary" [faIcon]="faAt" [label]="'header.online-appointment-link' | translate"
        (click)="goToOnlineAppointmentUrl()"></ng-casto-button>
      }

      <ng-container>
        @if (!customer.isLogged) {
        @if (!isInProject) {
        <ng-casto-button (click)="signIn()" [faIcon]="faUser" [label]="'header.nav1' | translate"></ng-casto-button>
        }
        } @else {
        @if (customer.fullName) {
        <span class="casto-tag white-tag customer-name" [innerHTML]="
              'header.customer-name'
                | translate
                  : {
                      name: customer.fullName,
                    }
            "></span>
        }
        <ng-casto-button (click)="askLogout()" [faIcon]="faUser"
          [label]="'header.user_nav2' | translate"></ng-casto-button>
        }
      </ng-container>
      }
      @if (customer.userDatas) {
      <ng-casto-customer-info></ng-casto-customer-info>
      }

      @if (displayProjectInfo) {
      <ng-casto-project-info></ng-casto-project-info>
      }
    </div>
  </div>
</div>

@if (bannerAlert; as alert) {
<div class="communication-alert-banner" #alertBanner
  [class.alert-medium]="alert.level === CommunicationLevel.ModerateAlert"
  [class.alert-high]="alert.level === CommunicationLevel.StrongAlert">
  <button type="button" class="communication-alert-banner__main" (click)="openAlert(alert)">
    <strong>{{ alert.title }}</strong>
    <span>{{ alert.content }}</span>
  </button>
  @if (bannerAlerts.length > 1) {
    <button type="button" class="communication-alert-count"
      [attr.aria-label]="(bannerAlerts.length === 2
        ? 'communications.header.otherAlertAria'
        : 'communications.header.otherAlertsAria') | translate: { count: bannerAlerts.length - 1 }"
      (click)="openNextBannerAlert()">
      {{ (bannerAlerts.length === 2
        ? 'communications.header.otherAlert'
        : 'communications.header.otherAlerts') | translate: { count: bannerAlerts.length - 1 } }}
    </button>
  }
</div>
}

<p-sidebar styleClass="customer-info-sidebar communications-sidebar" [(visible)]="communicationsPanelOpen" position="right" baseZIndex="4000"
  appendTo="body" [blockScroll]="true" (onHide)="closeCommunicationsPanel()">
  <ng-template pTemplate="header">
    <span class="casto-title decorator">{{ (communicationsPanelAlertsOnly ? 'communications.header.alertsPanelTitle' : 'communications.header.panelTitle') | translate }}</span>
  </ng-template>

  <div class="content communications-sidebar__content">
    <div class="communications-panel__filters" role="group"
      [attr.aria-label]="'communications.header.criticalityFilter' | translate">
      <span class="communications-panel__filters-label">{{ 'communications.header.criticalityFilter' | translate }}</span>
      @for (level of communicationsPanelLevelFilters; track level) {
        <button type="button" class="communications-panel-filter"
          [class.is-active]="communicationsPanelLevel === level"
          [class.level-information]="level === CommunicationLevel.Information"
          [class.level-moderate]="level === CommunicationLevel.ModerateAlert"
          [class.level-critical]="level === CommunicationLevel.StrongAlert"
          [attr.aria-pressed]="communicationsPanelLevel === level"
          (click)="filterCommunicationsPanel(level)">
          {{ (level === null ? 'communications.header.allLevels' : levelShortLabelKey(level)) | translate }}
          @if (unreadCommunicationsPanelCount(level); as unreadCount) {
            <span class="communications-panel-filter__unread"
              [attr.aria-label]="(unreadCount === 1
                ? 'communications.header.unreadCountOne'
                : 'communications.header.unreadCountMany') | translate: { count: unreadCount }">
              {{ unreadCount }}
            </span>
          }
        </button>
      }
    </div>
    @if (communicationsPanelGroups.length === 0) {
      <section class="communications-panel__empty">{{ 'communications.page.empty' | translate }}</section>
    } @else {
      <div class="communications-panel__groups">
        @for (group of communicationsPanelGroups; track group.date) {
          <section class="communications-panel-group">
            <h3 class="communications-panel-group__date">{{ group.date }}</h3>
            <div class="communications-panel__list">
              @for (communication of group.items; track communication.id) {
                <button type="button" class="communications-panel-item" [class.unread]="!communication.isRead"
                  [class.level-information]="communication.level === CommunicationLevel.Information"
                  [class.level-moderate]="communication.level === CommunicationLevel.ModerateAlert"
                  [class.level-critical]="communication.level === CommunicationLevel.StrongAlert"
                  (click)="openCommunicationFromPanel(communication)">
                  <div class="communications-panel-item__top">
                    <span class="communication-alert-tag communication-alert-tag--level">{{ levelShortLabelKey(communication.level) | translate }}</span>
                    @if (!communication.isRead) {
                      <span class="communications-panel-item__unread">{{ 'communications.page.unread' | translate }}</span>
                    }
                  </div>
                  <strong>{{ communication.title }}</strong>
                  <span>{{ communication.content }}</span>
                  <small>{{ communication.theme }} · {{ communication.publishingTeam }} · {{ formatParisDate(communication.publicationUtc) }}</small>
                </button>
              }
            </div>
          </section>
        }
      </div>
    }
  </div>
</p-sidebar>

@if (alertDialog; as alert) {
<ng-casto-communication-alert-dialog
  [alert]="alert"
  [canNavigate]="canNavigateAlertDialog"
  [currentPosition]="alertDialogPosition"
  [totalAlerts]="bannerAlerts.length"
  (closed)="closeAlert()"
  (acknowledged)="closeAlert()"
  (previousRequested)="openPreviousAlert()"
  (nextRequested)="openNextAlert()">
</ng-casto-communication-alert-dialog>
}
<p-toast position="bottom-right" [baseZIndex]="10000"></p-toast>
